webpackJsonp([1],{

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_rich_privacypolicy__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_style_css__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_css_style_css__);






new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__views_rich_privacypolicy__["a" /* default */]);
  }
}).$mount('#app');

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export doCopy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetQueryString; });
/* unused harmony export offline */
/* unused harmony export trim */


var doCopy = function doCopy(text) {
  var $div = document.createElement('div');
  $div.setAttribute('class', 'copy-div');
  $div.innerText = text;
  document.body.appendChild($div);

  var range = document.createRange();
  range.selectNode(document.querySelector(".copy-div"));
  var selection = window.getSelection();
  console.log(selection);
  if (selection.rangeCount > 0) selection.removeAllRanges();
  selection.addRange(range);
  document.execCommand('Copy');

  document.body.removeChild($div);
};

var GetQueryString = function GetQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  if (r !== null) return unescape(r[2]);
  return null;
};

var offline = function offline(that) {
  window.addEventListener('offline', function () {
    that.$message('', that.$t('netErr'));
  });
};

var trim = function trim(s) {
  var _s = s.replace(/^\s+|\s+$/, '');
  return _s;
};

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArticle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);


var origin = window.$envConfig && window.$envConfig.scannerApiMainDomain ? window.$envConfig.scannerApiMainDomain : window.location.origin;
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL = origin;
var getArticle = function getArticle(url, params, success, error) {
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (res) {
    success(res);
  }).catch(function (err) {
    error(err);
  });
};

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(false);
// imports


// module
exports.push([module.i, ".container[data-v-07f27e3a]{padding:.2rem .15rem;overflow-x:hidden;word-break:break-all;white-space:pre-line!important}.title[data-v-07f27e3a]{font-size:.4rem;text-align:center}.content[data-v-07f27e3a]{font-size:.2rem;margin-top:.2rem;line-height:1.5}", ""]);

// exports


/***/ }),

/***/ 361:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(99);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f27e3a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(370);
function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var normalizeComponent = __webpack_require__(369)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07f27e3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f27e3a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(359);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(372)("5fdd0925", content, true, {});

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(138);
__webpack_require__(93);
module.exports = __webpack_require__(137);


/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(157);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: '',
      content: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    var language = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_js__["a" /* GetQueryString */])('language') || window.navigator.language;
    var url =  false ? '/proxy-api/scanner_api/protocol/privacy_policy' : '/scanner_api/protocol/privacy_policy';
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http_js__["a" /* getArticle */])(url, { language: language }, function (res) {
      console.log(res.data.payload);
      var data = res.data.payload.article;
      _this.title = data.title;
      document.title = data.title;
      _this.content = data.content;
    }, function () {});
  }
});

/***/ })

},[376]);


// WEBPACK FOOTER //
// static/js/app.1fbfde3f2c380aff4d94.js